'use client';

import { Box, CloseButton, Drawer, Flex, Heading, IconButton, Portal } from '@chakra-ui/react';
import { observer } from 'mobx-react-lite';
import { useRouter } from 'next/navigation';
import { useCallback, useState } from 'react';
import { CiMenuFries } from 'react-icons/ci';

import UserAvatarMenu from '@components/common/UserAvatarMenu';
import { ColorModeButton } from '@components/ui/color-mode';
import NavigationLinks from '@features/marketplace/navigation/NavigationLinks';
import { PageNavigation } from '@features/marketplace/navigation/PageNavigation';
import CartIconButton from '@features/navigation/CartIconButton';
import { SearchIcon } from 'vectors';

const SidebarMenuButton = () => {
  const [open, setOpen] = useState(false);

  const onToggle = () => {
    setOpen(!open);
  };

  return (
    <Drawer.Root size="full" onOpenChange={onToggle} open={open}>
      <Drawer.Trigger asChild>
        <IconButton variant="ghost" _hover={{ bg: 'sidebar.hoverButton' }}>
          <CiMenuFries />
        </IconButton>
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content>
            <Drawer.Header>
              <Drawer.CloseTrigger asChild pos="initial">
                <CloseButton />
              </Drawer.CloseTrigger>
            </Drawer.Header>
            <Drawer.Body>
              <PageNavigation onSelect={onToggle} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};

const TopBar = () => {
  const router = useRouter();

  const onClickAppTitle = useCallback(() => {
    router.push('/marketplace');
  }, [router]);

  return (
    <Flex flexDirection="row" justifyContent="space-between" p={1} alignItems="center">
      <Heading size="md" cursor="pointer" hideBelow="lg" onClick={onClickAppTitle}>
        Sidejuice
      </Heading>
      <Flex flexDirection="row" gap={2} alignItems="center">
        <Box hideFrom="lg">
          <SidebarMenuButton />
        </Box>
        <Box hideBelow="lg">
          <NavigationLinks />
        </Box>
      </Flex>
      <Flex flexDirection="row" gap={2} alignItems="center">
        <ColorModeButton />
        <IconButton
          _hover={{
            backgroundColor: 'sidebar.hover',
          }}
          variant="ghost"
          size="sm"
        >
          <SearchIcon />
        </IconButton>
        <CartIconButton />
        <UserAvatarMenu shouldRedirectToLogin={false} hideSettings showOrgList={false} />
      </Flex>
    </Flex>
  );
};

export default observer(TopBar);
